import React, { useState, useEffect } from "react";
import "./CursorCat.css";

const CursorCat = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const [isRunning, setIsRunning] = useState(false);
  const [direction, setDirection] = useState("right");

  useEffect(() => {
    let timeoutId;

    const handleMouseMove = (e) => {
      if (e.clientX > 0 && e.clientY > 0) {
        setIsVisible(true);
      }

      const newX = e.clientX - 15;
      const newY = e.clientY - 15;

      if (position.x !== 0) {
        if (newX > position.x) {
          setDirection("right");
        } else if (newX < position.x) {
          setDirection("left");
        }
      }

      setPosition({ x: newX, y: newY });
      setIsRunning(true);

      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsRunning(false);
      }, 150);
    };

    const handleMouseLeave = () => {
      setIsVisible(false);
    };

    const handleMouseEnter = () => {
      setIsVisible(true);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseleave", handleMouseLeave);
    document.addEventListener("mouseenter", handleMouseEnter);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseleave", handleMouseLeave);
      document.removeEventListener("mouseenter", handleMouseEnter);
      clearTimeout(timeoutId);
    };
  }, [position.x]);

  if (!isVisible) return null;

  return (
    <div
      className={`cursor-cat ${isRunning ? "running" : "idle"} ${direction}`}
      style={{
        left: position.x + "px",
        top: position.y + "px",
      }}
    >
      {/* Small Black Cat */}
      <svg 
        width="30" 
        height="30" 
        viewBox="0 0 30 30" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="cat-svg"
      >
        {/* Body */}
        <ellipse cx="15" cy="22" rx="10" ry="6" fill="#1a1a1a"/>
        
        {/* Head */}
        <circle cx="15" cy="14" r="8" fill="#1a1a1a"/>
        
        {/* Left Ear */}
        <polygon points="9,10 6,3 12,7" fill="#1a1a1a"/>
        <polygon points="9,10 7,5 11,8" fill="#2a2a2a"/>
        
        {/* Right Ear */}
        <polygon points="21,10 24,3 18,7" fill="#1a1a1a"/>
        <polygon points="21,10 23,5 19,8" fill="#2a2a2a"/>
        
        {/* Eyes */}
        <circle cx="12" cy="13" r="2.5" fill="#f5f542"/>
        <circle cx="18" cy="13" r="2.5" fill="#f5f542"/>
        
        {/* Pupils */}
        <circle cx="12" cy="13" r="1.5" fill="#1a1a1a"/>
        <circle cx="18" cy="13" r="1.5" fill="#1a1a1a"/>
        
        {/* Eye shine */}
        <circle cx="11.5" cy="12.5" r="0.5" fill="white" opacity="0.8"/>
        <circle cx="17.5" cy="12.5" r="0.5" fill="white" opacity="0.8"/>
        
        {/* Nose */}
        <circle cx="15" cy="15.5" r="1" fill="#ff6b6b"/>
        
        {/* Mouth */}
        <path d="M14 16.5 Q15 17.5 16 16.5" stroke="#1a1a1a" strokeWidth="0.5" fill="none"/>
        
        {/* Whiskers */}
        <line x1="8" y1="15" x2="4" y2="14" stroke="#333" strokeWidth="0.5"/>
        <line x1="8" y1="16" x2="4" y2="16" stroke="#333" strokeWidth="0.5"/>
        <line x1="8" y1="17" x2="4" y2="18" stroke="#333" strokeWidth="0.5"/>
        <line x1="22" y1="15" x2="26" y2="14" stroke="#333" strokeWidth="0.5"/>
        <line x1="22" y1="16" x2="26" y2="16" stroke="#333" strokeWidth="0.5"/>
        <line x1="22" y1="17" x2="26" y2="18" stroke="#333" strokeWidth="0.5"/>
        
        {/* Tail */}
        <path d="M25 22 Q28 20 27 17 Q26 15 28 14" stroke="#1a1a1a" strokeWidth="2" fill="none" strokeLinecap="round"/>
        
        {/* Paws */}
        <ellipse cx="11" cy="24" rx="2" ry="1.5" fill="#1a1a1a"/>
        <ellipse cx="19" cy="24" rx="2" ry="1.5" fill="#1a1a1a"/>
        
        {/* Running legs */}
        <g className="legs-animation">
          <ellipse cx="9" cy="26" rx="1.5" ry="2" fill="#1a1a1a" className="leg front-left"/>
          <ellipse cx="21" cy="26" rx="1.5" ry="2" fill="#1a1a1a" className="leg front-right"/>
          <ellipse cx="12" cy="26" rx="1.5" ry="2" fill="#1a1a1a" className="leg back-left"/>
          <ellipse cx="18" cy="26" rx="1.5" ry="2" fill="#1a1a1a" className="leg back-right"/>
        </g>
      </svg>
    </div>
  );
};

export default CursorCat;